var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.189,
    height: 25.189,
    viewBox: "0 0 25.189 25.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path474",
    d: "M0-682.665H25.189v25.189H0Z",
    transform: "translate(0 682.665)",
    fill: "#828282",
    stroke: "#828282",
    strokeWidth: 1.333
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g468",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g470",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g472",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g478",
    transform: "translate(2.214 8.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path480",
    d: "M0,0H14.366a7.626,7.626,0,0,1,0,15.251H2.755",
    fill: "rgba(0,0,0,0)",
    stroke: "#828282",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g482",
    transform: "translate(1.378 1.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path484",
    d: "M-169.505-340.295-176-346.814l6.494-6.519",
    transform: "translate(176 353.332)",
    fill: "rgba(0,0,0,0)",
    stroke: "#828282",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.25ae9837a313a2c4483f380dbea7329f.svg";
export { ForwardRef as ReactComponent };